module.exports = __webpack_public_path__ + "img/001_05.fa7f0a6a.jpg";